import React from 'react'
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { User } from 'TypeDefs/Goal'

type TaskOwnerSelectorProps = {
  owner: User | null
  onSelectOwner: (event: SelectChangeEvent<string>) => void
}

export const TaskOwnerSelector = ({
  owner,
  onSelectOwner,
}: TaskOwnerSelectorProps) => {
  const { teamOptions } = useNonprofitOrgTeam()

  // Convert owner id to string for comparison
  const currentValue = owner?.id?.toString() || ''

  // Create a map of id to option for easy lookup
  const optionMap = new Map(teamOptions.map((option) => [option.value, option]))

  // Check if the current value exists in the options
  const isValidValue = currentValue === '' || optionMap.has(currentValue)

  return (
    <FormControl fullWidth>
      <InputLabel id='task-owner-select-label'>Assign an Owner</InputLabel>
      <Select
        labelId='task-owner-select-label'
        value={isValidValue ? currentValue : ''}
        onChange={onSelectOwner}
        label='Assign an Owner'
      >
        <MenuItem value=''>{owner ? 'Unassign' : 'Assign an Owner'}</MenuItem>
        {teamOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
